import React from 'react'
import PropTypes from 'prop-types'

// @ts-ignore
import ListItem from "./row"
import FirstColumn from "./first-column"
import GenericListModule from "../../generic-list-module";
import AggregationRow from "../aggregation/aggregation-row";

type Props = {
    module: GenericListModule,
    items: any[],
}

export default function ListItems(props:any) {

    // NO RECORDS
    if (!props.items || props.items.length === 0) {
        const message = typeof props.module.noItemsMessage === 'string' ?
            <div className="cell ui5-txt-not-important-small" style={{width: '100%'}}>
                {props.module.noItemsMessage}
            </div>
            :
            props.module.noItemsMessage

        return (
            <div className="empty-table-row">
                <FirstColumn module={props.module}/>
                {message}
            </div>
        )
    }

    return (
        <>
            {_.map(props.items, (item, key)=>
                <ListItem key={item.id} dndManager={props.module.dndManager} module={props.module} data={item}/>
            )}

            {props.module.hasAggregation && <AggregationRow items={props.items} module={props.module} />}

        </>
    );
}
